var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShuffle = function SvgShuffle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "shuffle_svg__a",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#shuffle_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m16.6 18-3.175-3.175L14.85 13.4 18 16.55V15q0-.424.288-.713A.97.97 0 0 1 19 14q.424 0 .712.287.288.288.288.713v4q0 .424-.288.712A.97.97 0 0 1 19 20h-4a.97.97 0 0 1-.713-.288A.97.97 0 0 1 14 19q0-.424.287-.712A.97.97 0 0 1 15 18zM18 7.4 5.7 19.7a.95.95 0 0 1-.7.275.95.95 0 0 1-.7-.275.95.95 0 0 1-.275-.7q0-.425.275-.7L16.6 6H15a.97.97 0 0 1-.713-.287A.97.97 0 0 1 14 5q0-.424.287-.713A.97.97 0 0 1 15 4h4q.424 0 .712.287Q20 4.576 20 5v4q0 .424-.288.713A.97.97 0 0 1 19 10a.97.97 0 0 1-.712-.287A.97.97 0 0 1 18 9zm-8.825 3.175L4.275 5.7A.95.95 0 0 1 4 5q0-.425.275-.7a.93.93 0 0 1 .688-.275q.412 0 .712.275l4.9 4.875z"
  }))));
};
export default SvgShuffle;